import { type LineItem } from "../models/CartData";
import { userIsSalesman } from "~/domains/user/utils/roles";
import * as QuoteUpdateApi from "~/features/cart/activeQuote/api/updateQuoteEntry";
import * as CartUpdateApi from "./UpdatePackageEntry";
import * as CartDeleteApi from "./DeletePackageEntry";
import * as QuoteAddApi from "~/features/cart/activeQuote/api/addToQuote";
import * as CartAddApi from "./AddToCart";
import * as CartLoadApi from "./CartView";
import * as QuoteLoadApi from "~/features/cart/activeQuote/api/quoteView";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { TransformedCartData } from "../transformers/CartResponseTransformer";

export function sendDeleteEntry(entry: LineItem): Promise<unknown> {
  entry = { ...entry, quantity: 0 };
  if (userIsSalesman()) {
    const apiItem = QuoteUpdateApi.fromLineItem(entry);
    return QuoteUpdateApi.sendUpdate(apiItem);
  } else {
    const apiItem = CartUpdateApi.fromLineItem(entry, []);
    return CartDeleteApi.sendDelete(apiItem);
  }
}

export function sendBulkEditEntry(items: LineItem[], subLineItemsByParentId: Dict<LineItem[]>): Promise<unknown> {
  if (userIsSalesman()) {
    const apiItems = items.map((item) => QuoteUpdateApi.fromLineItem(item));
    return QuoteUpdateApi.sendBulkUpdate(apiItems);
  } else {
    const apiItems = items.map((item) => CartUpdateApi.fromLineItem(item, subLineItemsByParentId[item.id] ?? []));
    return CartUpdateApi.sendBulkUpdate(apiItems);
  }
}

export async function sendAddEntry(item: LineItem, descriptor: ProductDescriptor): Promise<number> {
  let result;
  if (userIsSalesman()) {
    result = await QuoteAddApi.sendAddToQuote(QuoteAddApi.fromLineItem(item, descriptor));
    result = await result.json();
    return result[0] as number;
  } else {
    result = await CartAddApi.sendAddToCart(CartAddApi.fromLineItem(item, [], descriptor), true);
    return result[0].pk as number;
  }
}

export async function loadCart(): Promise<TransformedCartData | null> {
  if (userIsSalesman()) {
    return QuoteLoadApi.getData();
  } else if (userHasPermission(Permission.ADD_TO_CART)) {
    return CartLoadApi.getData();
  }
  return Promise.resolve(null);
}
